// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5aac1ac9849e8f2360ca","655":"b6742abf396ce40a9800"}[chunkId] + ".js";
};